import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function AzureClientIdField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Client ID cannot be blank.');
    } else if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(newValue)) {
      setError('Client ID must be a valid UUID format (e.g., xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Client ID'
          id='client-id'
          aria-describedby='client-id-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={error}
          value={value}
        />
        {error ? (
          <FormHelperText id='client-id-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='client-id-helper-text'>
            Enter the Azure Client ID
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

